<template>
  <word-counter :word-count="counter" :max-word="appMaxSize" :error="appInvalidInput"/>
</template>

<script>
import { defineComponent, inject } from 'vue'
import WordCounter from './WordCounter.vue';

export default defineComponent({
  components: {
    WordCounter 
  },
  setup(){
    let counter = inject('appCounter');
    let appMaxSize = inject('appMaxSize');
    let appInvalidInput = inject('appInvalidInput');
    return {
      counter,
      appMaxSize,
      appInvalidInput
    }
  },
})
</script>
